// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"d138233c","651":"b959e208"}[chunkId] + ".chunk.js";
};